import { OPEN } from "../constants/editorPanelStatuses";
import { SMALL } from "../constants/editorPreviewStatuses";

import * as actionTypes from "../constants/actionTypes";

// initialState
export const initialState = {
  selectedSurfaceId: 0,
  selectedPatternId: 0,
  previewStatus: SMALL,
  previewFullscreen: false,
  leftPanelStatus: OPEN,
  rightPanelStatus: OPEN,
  patternConfigs: {},
  modelId: undefined
};

// reducere
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SELECT_EDITOR_SURFACE:
      return {
        ...state,
        selectedSurfaceId: action.id
      };
    case actionTypes.SELECT_EDITOR_PATTERN:
      return {
        ...state,
        selectedPatternId: action.id
      };
    case actionTypes.UPDATE_EDITOR_LEFT_PANEL_STATUS:
      return {
        ...state,
        leftPanelStatus: action.status
      };
    case actionTypes.UPDATE_EDITOR_RIGHT_PANEL_STATUS:
      return {
        ...state,
        rightPanelStatus: action.status
      };
    case actionTypes.UPDATE_EDITOR_PREVIEW_STATUS:
      return {
        ...state,
        previewStatus: action.status
      };
    case actionTypes.UPDATE_EDITOR_PATTERN_CONFIGS:
      const patternConfigs = state.patternConfigs;
      patternConfigs[action.id] = action.config;

      return {
        ...state,
        patternConfigs: patternConfigs
      };
    case actionTypes.CLEAR_EDITOR:
      return initialState;
    case actionTypes.TOGGLE_EDITOR_PREVIEW_FULLSCREEN:
      return {
        ...state,
        previewFullscreen: !state.previewFullscreen
      };
    case actionTypes.SET_EDITOR_MODEL:
      return {
        ...state,
        modelId: action.payload.id
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/editor.js